import React from "react";
import { ClipboardList, Layers, MessageCircle, QrCode, Store } from "lucide-react";
import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "@/components/icons/ModulosIcons";

import { MODULOS } from "../formato";
import Bloco from "./Bloco";
import Opcao from "./Opcao";

// Mesmos ícones do menu do topo do painel; Totem e Mesa QR ganham os seus.
const ICONES = { Cardapio: Store, Delivery: MotoEntregaIcon, Balcao: CaixaRegistradoraIcon, Totem: TotemIcon, Mesas: MesaIcon, MesaQR: QrCode, Comandas: ClipboardList, ChatBot: MessageCircle };

export default function SecaoModulos({ config, onMudar }) {
  const marcados = new Set(config.modulos || ["Cardapio"]);
  const alternar = (id) => {
    const novo = new Set(marcados);
    if (novo.has(id)) novo.delete(id); else novo.add(id);
    if (novo.size === 0) return; // pelo menos um módulo
    onMudar("modulos", MODULOS.map((m) => m.id).filter((m) => novo.has(m)));
  };
  return (
    <Bloco icone={Layers} titulo="Onde a campanha vale"
      subtitulo="A oferta do cliente é a mesma em todos os módulos marcados. Nos de atendente, ela entra quando o cliente é identificado no pedido. Sem o WhatsApp marcado, a CLEO vende no preço normal e diz que a oferta é exclusiva do cardápio digital.">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5" data-e2e="modulos-campanha">
        {MODULOS.map((m) => (
          <Opcao key={m.id} e2e={`modulo-${m.id}`} icone={ICONES[m.id]} rotulo={m.rotulo} dica={m.dica}
            marcado={marcados.has(m.id)} onAlternar={() => alternar(m.id)} />
        ))}
      </div>
    </Bloco>
  );
}
